import React, { useEffect, useState, useRef } from "react";
import Navber from "./Navber.jsx";
import { useParams, useNavigate } from "react-router-dom";
import api from "../Api.js";
import "../Styles/HotelDetails.css";
import SafeComponent from "./SafeComponent.jsx";
import MapWrapper from "./Safemap.jsx";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import FullScreenSpin from "./Helping Component/Fullscreeenspinner.jsx";
import { showToast } from "./PopupMessage.jsx";
import humanImg from "../Images/human_icon.jpg";
import ImageLightbox from "../Components/Helping Component/ImageZoom.jsx";
import noimg from "../Images/noimg.jpg";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import ManualImageSlider from "./Helping Component/ManualImageSlider.jsx";

function HotelDetails() {
  const [hotelDetails, setHotelDetails] = React.useState(null);
  const [hotelRooms, setHotelRooms] = React.useState([]);
  const [aminities, setAmenities] = React.useState([]);
  const [selectedRoom, setSelectedRoom] = useState(null);
  const [accessToken, setAccessToken] = useState(null);
  const [bookingID, setBookingID] = useState(null);
  const [roomID, setRoomID] = useState(null);
  const [roomImages, setRoomImages] = useState([]);
  const [infants, setInfants] = useState(0);
  const [children, setChildren] = useState(0);
  const [adults, setAdults] = useState(1);
  const [totalPrice, setTotalPrice] = useState(0);
  const [selectedImage, setSelectedImage] = useState(null);
  const [price, setPrice] = useState(0);
  const navigate = useNavigate();
  const [destination, setDestination] = useState("");
  const [checkIn, setCheckIn] = useState();
  const [checkOut, setCheckOut] = useState();
  const [availableRoom, setAvailableRoom] = useState([]);
  const [loading, setLoading] = useState(false);
  const [hotelimg, setHotelimg] = useState([]);
  const [reviews, setReviews] = useState([]);

  const { slugId } = useParams();
  const parts = slugId.split("-");
  const random = parseInt(parts.pop());
  const encodedId = parseInt(parts.pop());
  const id = encodedId - random;

  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [currentImages, setCurrentImages] = useState([]);
  const [expanded, setExpanded] = useState(false);
  const [showMealModal, setShowMealModal] = useState(false);
  const [roomsCount, setRoomsCount] = useState(1);
  const roomsRef = React.useRef(null);
  const InputDiv = React.useRef(null);

  const [mealCount, setMealCount] = useState({
    breakfast: 0,
    lunch: 0,
    dinner: 0,
  });

  const scrollInput = () => {
    if (!InputDiv.current) return;
    InputDiv.current.scrollIntoView({ top: 0, behavior: "smooth" });
  };

  function formatTime(time) {
    if (!time) return "--:--";
    let [h, m] = time.split(":");
    h = Number(h);
    const period = h >= 12 ? "PM" : "AM";
    h = h % 12 || 12;
    return `${h}:${m} ${period}`;
  }

  function calculateNights(checkIn, checkOut) {
    const inDate = new Date(checkIn);
    const outDate = new Date(checkOut);
    const diffTime = outDate - inDate;
    const nights = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return nights;
  }

  useEffect(() => {
    const fetchHotelDetails = async () => {
      try {
        setAccessToken(localStorage.getItem("accessToken") || null);
        const res = await api.get(`/hotels/${id}`);
        if (res.data.status === true) {
          setHotelDetails(res?.data?.data);
          setHotelimg(res?.data?.data?.image);
          setHotelRooms(res?.data?.data?.rooms || []);
          setRoomImages(res?.data?.data?.rooms?.images || []);
          setSelectedRoom(res?.data?.data?.rooms[0] || null);
          setAmenities(res?.data?.data?.amenities || []);
        }
      } catch (err) {
        console.log(err);
      }
    };

    const getReviews = async () => {
      try {
        const response = await api.get("/reviews");
        if (response.data.status === true) {
          setReviews(response?.data?.data || []);
        }
      } catch (err) {
        console.log(err);
      }
    };

    fetchHotelDetails();
    getReviews();
  }, [id]);

  const hotelreviews = hotelDetails
    ? reviews.filter((r) => r.hotel_id === hotelDetails.id)
    : [];

  const handleRoomChange = (e) => {
    const roomId = e.target.value;
    const room = hotelRooms.find((r) => r.id.toString() === roomId);
    setRoomID(roomId);
    if (room) setSelectedRoom(room);
  };

  useEffect(() => {
    if (!selectedRoom) return;

    const {
      room_capacity,
      max_guests,
      price_per_night,
      adult_price,
      child_price,
    } = selectedRoom;

    const totalGuests = adults + children;
    if (totalGuests > 1 || roomsCount > 1) {
      if (!accessToken) {
        showToast("Please log in to continue booking.", "error");
        navigate("/signup");
        return;
      }
    }

    if (totalGuests > max_guests * roomsCount) {
      showToast(
        `Maximum Guest: ${max_guests}. please select multiple room`,
        "warning"
      );
      return;
    }

    const basePrice = Number(price_per_night || 0);
    const extraAdultPrice = Number(adult_price || 0);
    const extraChildPrice = Number(child_price || 0);

    if (totalGuests <= room_capacity * roomsCount) {
      setTotalPrice(basePrice * roomsCount);
      return;
    }

    let remainingExtra = totalGuests - room_capacity * roomsCount;
    const extraChildren = Math.min(remainingExtra, children);
    remainingExtra -= extraChildren;
    const extraAdults = remainingExtra;

    const total =
      basePrice * roomsCount +
      extraChildren * extraChildPrice +
      extraAdults * extraAdultPrice;

    setTotalPrice(total);
  }, [selectedRoom, adults, children, roomsCount]);

  const maxRooms = selectedRoom?.no_of_rooms || 1;

  const BookNow = async () => {
    if (!checkIn || !checkOut) {
      showToast("Please select check-in and check-out dates.", "warning");
      return;
    }
    if (!selectedRoom) {
      showToast("Please select a room type.", "warning");
      return;
    }
    if (adults + children + infants > selectedRoom.max_guests * roomsCount) {
      showToast(
        `The selected room can accommodate a maximum of ${selectedRoom.max_guests} guests.`,
        "warning"
      );
      return;
    }
    try {
      if (!accessToken) {
        showToast("Please log in to book a room.", "warning");
        navigate("/signup");
        return;
      }

      const nights = calculateNights(checkIn, checkOut);
      if (checkIn >= checkOut) {
        showToast("Please give right Date and Time...", "warning");
        return;
      }

      const bookingData = {
        hotel_id: id,
        room_id: selectedRoom.id,
        check_in: dayjs(checkIn).format("YYYY-MM-DD HH:mm:ss"),
        check_out: dayjs(checkOut).format("YYYY-MM-DD HH:mm:ss"),
        adults,
        children,
        infants,
        total_price: nights * roomTotalPrice + mealTotal * nights,
        no_of_rooms: roomsCount,
        meals: {
          breakfast_qty: mealCount.breakfast,
          lunch_qty: mealCount.lunch,
          dinner_qty: mealCount.dinner,
        },
        meal_price: mealTotal * nights,
      };

      const res = await api.post("/bookings/hotel-room", bookingData, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      });

      if (res.data.status === true) {
        setBookingID(res?.data?.data?.id);
        navigate(`/hotel/reviewbooking/${res?.data?.data?.id}`, {
          state: {
            bookingDetails: res?.data?.data,
            hotel: hotelDetails,
            Time: bookingData,
            FinalPrice: roomTotalPrice,
            MealCount: mealCount,
            MealPrice: mealTotal,
            NightCount: nights,
            RoomCount: roomsCount,
          },
        });
      } else {
        alert(res.message || "Booking failed. Please try again.");
      }
    } catch (err) {
      showToast(err?.response?.data?.message, "warning");
    }
  };

  const scrollRooms = () => {
    roomsRef.current?.scrollIntoView({ top: 0, behavior: "smooth" });
  };

  const availability = async () => {
    if (!checkIn || !checkOut) {
      showToast("Please select check-in and check-out dates.", "warning");
      return;
    }
    if (!selectedRoom) {
      showToast("Please select a room type.", "warning");
      return;
    }
    if (adults + children + infants > selectedRoom.max_guests) {
      showToast(
        `The selected room can accommodate a maximum of ${selectedRoom.max_guests} guests.`,
        "warning"
      );
      return;
    }
    try {
      if (!accessToken) {
        showToast("Please log in to book a room.", "warning");
        navigate("/signup");
        return;
      }

      const bookingData = {
        hotel_id: id,
        check_in: dayjs(checkIn).format("YYYY-MM-DD HH:mm:ss"),
        check_out: dayjs(checkOut).format("YYYY-MM-DD HH:mm:ss"),
      };
      if (bookingData.check_in >= bookingData.check_out) {
        showToast("Please give right Date and Time...", "warning");
        return;
      }

      setLoading(true);
      const res = await api.post("/check-room-availability", bookingData, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      });

      if (res.data.status === true) {
        if (Array.isArray(availableRoom) && availableRoom.length > 0) {
          showToast(
            `${availableRoom.length} Types of room are available...`,
            "success"
          );
        }
        setAvailableRoom(res?.data?.data);
        setLoading(false);
        scrollRooms();
      } else {
        alert(res.data.message || "Booking failed. Please try again.");
      }
    } catch (err) {
      console.log(err);
    }
  };

  const availability1 = async () => {
    if (!checkIn || !checkOut) {
      showToast("Please select check-in and check-out dates.", "error");
      scrollInput();
      return;
    }
    if (!selectedRoom) {
      showToast("Please select a room type.", "warning");
      return;
    }
    if (adults + children + infants > selectedRoom.max_guests) {
      showToast(
        `The selected room can accommodate a maximum of ${selectedRoom.max_guests} guests.`,
        "warning"
      );
      return;
    }
    try {
      if (!accessToken) {
        showToast("Please log in to book a room.", "warning");
        navigate("/signup");
        return;
      }

      const bookingData = {
        hotel_id: id,
        check_in: dayjs(checkIn).format("YYYY-MM-DD HH:mm:ss"),
        check_out: dayjs(checkOut).format("YYYY-MM-DD HH:mm:ss"),
      };
      if (bookingData.check_in >= bookingData.check_out) {
        showToast("Please give right Date and Time...", "warning");
        return;
      }

      setLoading(true);
      const res = await api.post("/check-room-availability", bookingData, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      });

      if (res.data.status === true) {
        if (Array.isArray(availableRoom) && availableRoom.length > 0) {
          showToast(
            `${availableRoom.length} Types of room are available...`,
            "success"
          );
        }
        setAvailableRoom(res?.data?.data);
        setLoading(false);
      } else {
        alert(res.data.message || "Booking failed. Please try again.");
      }
    } catch (err) {
      console.log(err);
    }
  };

  const totalRatings = hotelreviews.reduce(
    (sum, r) => sum + Number(r.rating || 0),
    0
  );
  const averageRating =
    hotelreviews.length > 0
      ? (totalRatings / hotelreviews.length).toFixed(1)
      : "No ratings yet";

  const RatingsText = (averageRating) => {
    if (averageRating >= 0 && averageRating < 1) return <span>Pore</span>;
    if (averageRating >= 1 && averageRating < 2) return <span>Average</span>;
    if (averageRating >= 2 && averageRating < 3) return <span>Good</span>;
    if (averageRating >= 3 && averageRating < 4) return <span>Very Good</span>;
    if (averageRating >= 4 && averageRating <= 5) return <span>Excellent</span>;
    return <span>No ratings yet</span>;
  };

  const handleOpenGallery = (index) => {
    const images = hotelDetails?.gallery_images || [];
    if (!images.length) return;
    const ordered = [images[index], ...images.filter((_, i) => i !== index)];
    setCurrentImages(ordered);
    setLightboxOpen(true);
  };

  const handleOpenRoomGallery = (index, room) => {
    const list = (room?.images || []).map((img) => img.image).filter(Boolean);
    if (!list.length) return;
    const ordered = [list[index], ...list.filter((_, i) => i !== index)];
    setCurrentImages(ordered);
    setLightboxOpen(true);
  };

  const mealPrices = {
    breakfast: selectedRoom?.breakfast === 1 ? selectedRoom.breakfast_price : 0,
    lunch: selectedRoom?.lunch === 1 ? selectedRoom.lunch_price : 0,
    dinner: selectedRoom?.dinner === 1 ? selectedRoom.dinner_price : 0,
  };

  const updateMealCount = (meal, type) => {
    setMealCount((prev) => {
      const value =
        type === "inc" ? prev[meal] + 1 : Math.max(0, prev[meal] - 1);
      return { ...prev, [meal]: value };
    });
  };

  const mealTotal =
    mealCount.breakfast * mealPrices.breakfast +
    mealCount.lunch * mealPrices.lunch +
    mealCount.dinner * mealPrices.dinner;

  const roomTotalPrice = totalPrice;

  const applyStaticTime = (dateValue, timeStr) => {
    if (!dateValue || !timeStr) return null;
    const [hour, minute] = timeStr.split(":").map(Number);
    return dayjs(dateValue)
      .hour(hour)
      .minute(minute)
      .second(0)
      .toDate();
  };

  return (
    <div>
      <div style={{ backgroundColor: "#f0f0f0" }}>
        <Navber />
      </div>

      <ImageLightbox
        open={lightboxOpen}
        setOpen={setLightboxOpen}
        images={currentImages}
      />

      <div className="hotelDetail-container">
        <div className="hotelDetail-grid">
          {/* ================= LEFT ================= */}
          <div className="hotelDetail-left animate-fadeIn">
            <div className="hotelDetail-hero">
              <ManualImageSlider
                images={hotelDetails?.gallery_images || []}
                alt={hotelDetails?.name || "hotel"}
                variant="hero"
                onImageClick={handleOpenGallery}
              />

              <h1 className="hotelDetail-title">{hotelDetails?.name}</h1>

              <div className="hotelDetail-timeRow">
                <span>
                  Start Check in : {formatTime(hotelDetails?.check_in_time)}
                </span>
                <span>
                  Last Check out : {formatTime(hotelDetails?.check_out_time)}
                </span>
              </div>
            </div>

            <p
              className={`hotelDetail-description ${
                expanded ? "expanded" : ""
              }`}
            >
              <SafeComponent
                html={hotelDetails?.description || "No description available."}
              />
            </p>

            {hotelDetails?.description && (
              <span
                className="show-more-btn1"
                onClick={() => setExpanded(!expanded)}
              >
                {expanded ? "Show less" : "Show more..."}
              </span>
            )}

            {/* Amenities */}
            {aminities.length > 0 && (
              <div className="hotelDetail-tags">
                {aminities.map((amenity, index) => (
                  <span className="hotelDetail-tag" key={index}>
                    {amenity?.name}
                  </span>
                ))}
              </div>
            )}

            {/* Rooms */}
            <div ref={roomsRef}>
              <h2 className="hotelDetail-amenitiesTitle">
                Choose Your Best Luxury
              </h2>
              <div className="hotelDetail-amenitiesList">
                {hotelRooms?.map((room) => {
                  const avail = availableRoom.find(
                    (a) => a.room_id === room.id
                  );
                  const roomImagesList = (room?.images || [])
                    .map((img) => img.image)
                    .filter(Boolean);

                  return (
                    <div
                      key={room.id}
                      className={`jr-room-card ${
                        selectedRoom?.id === room.id
                          ? "jr-room-card--active"
                          : ""
                      }`}
                      onClick={() => setSelectedRoom(room)}
                    >
                      <div className="jr-room-image">
                        <ManualImageSlider
                          images={roomImagesList}
                          alt={room?.name || "room"}
                          variant="room"
                          onImageClick={(i) =>
                            handleOpenRoomGallery(i, room)
                          }
                        />
                        {avail?.available_rooms === 0 && (
                          <span className="jr-room-badge">Sold Out</span>
                        )}
                      </div>

                      <div className="jr-room-info">
                        <h4 className="jr-room-title">{room?.name}</h4>
                        <p className="jr-room-meta">
                          👥 Max Guests: {room?.max_guests} &nbsp;|&nbsp; 🛏{" "}
                          {room?.room_type}
                        </p>
                        <p className="jr-room-food">
                          🍽️ Available Food:
                          {room.breakfast ? " Breakfast" : ""}
                          {room.lunch ? " Lunch" : ""}
                          {room.dinner ? " Dinner" : ""}
                          {!room.breakfast &&
                            !room.lunch &&
                            !room.dinner &&
                            " No Meals"}
                        </p>
                      </div>

                      <div className="jr-room-price">
                        <button
                          className="check_availability_button"
                          onClick={(e) => {
                            e.stopPropagation();
                            availability1();
                          }}
                        >
                          Check Availability
                        </button>
                        <span className="jr-room-amount">
                          ₹{room?.price_per_night}
                        </span>
                        <span className="jr-room-night">per night</span>

                        {avail &&
                          (avail.available_rooms > 0 ? (
                            <span className="jr-room-available">
                              {avail.available_rooms} Rooms Available
                            </span>
                          ) : (
                            <span className="jr-room-soldout-text">
                              Sold Out
                            </span>
                          ))}
                      </div>
                    </div>
                  );
                })}
              </div>
              {loading && <FullScreenSpin />}
            </div>
          </div>

          {/* ================= RIGHT ================= */}
          <div className="hotelDetail-right animate-fadeIn">
            <div className="hotelDetail-bookingBox animate-slideInRight">
              <h3 className="hotelDetail-bookingTitle">Book Your Stay</h3>

              {selectedRoom &&
                hotelRooms
                  ?.filter((a) => a.id === selectedRoom.id)
                  .map((room) => (
                    <React.Fragment key={room.id}>
                      <p className="hotelDetail-bookingSub">
                        Max Guests per {room.room_type}:{" "}
                        <b>{room?.max_guests}</b>
                      </p>
                      <p className="hotelDetail-bookingSub">
                        Total rooms: <b>{room?.no_of_rooms}</b>
                      </p>
                      <p className="hotelDetail-bookingSub">
                        Selected room: <b>{room.room_type}</b>
                      </p>
                    </React.Fragment>
                  ))}

              <p className="hotelDetail-price">
                ₹{roomTotalPrice}{" "}
                <span className="hotelDetail-priceSub">
                  ({roomsCount} room{roomsCount > 1 ? "s" : ""} / day)
                </span>
              </p>

              <div className="hotelDetail-dateInputs" ref={InputDiv}>
                <div className="guest-select-wrapper">
                  <select
                    className="hotelDetail-selectRoomType"
                    onChange={(e) => setAdults(Number(e.target.value))}
                  >
                    <option value="1">Person (4yrs+)</option>
                    {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((n) => (
                      <option key={n} value={n}>
                        {n}
                      </option>
                    ))}
                  </select>

                  <select
                    className="hotelDetail-selectRoomType"
                    onChange={(e) => setChildren(Number(e.target.value))}
                  >
                    <option value="0">Child (0-4yrs)</option>
                    {[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((n) => (
                      <option key={n} value={n}>
                        {n}
                      </option>
                    ))}
                  </select>
                </div>

                {showMealModal && (
                  <div className="meal-modal-backdrop">
                    <div className="meal-modal">
                      <h3>Add Meals / Day</h3>

                      {mealPrices.breakfast > 0 && (
                        <div className="meal-row">
                          <span>🍳 Breakfast (₹{mealPrices.breakfast})</span>
                          <div className="counter">
                            <button
                              onClick={() =>
                                updateMealCount("breakfast", "dec")
                              }
                            >
                              −
                            </button>
                            <span>{mealCount.breakfast}</span>
                            <button
                              onClick={() =>
                                updateMealCount("breakfast", "inc")
                              }
                            >
                              +
                            </button>
                          </div>
                        </div>
                      )}

                      {mealPrices.lunch > 0 && (
                        <div className="meal-row">
                          <span>🍛 Lunch (₹{mealPrices.lunch})</span>
                          <div className="counter">
                            <button
                              onClick={() => updateMealCount("lunch", "dec")}
                            >
                              −
                            </button>
                            <span>{mealCount.lunch}</span>
                            <button
                              onClick={() => updateMealCount("lunch", "inc")}
                            >
                              +
                            </button>
                          </div>
                        </div>
                      )}

                      {mealPrices.dinner > 0 && (
                        <div className="meal-row">
                          <span>🍽️ Dinner (₹{mealPrices.dinner})</span>
                          <div className="counter">
                            <button
                              onClick={() => updateMealCount("dinner", "dec")}
                            >
                              −
                            </button>
                            <span>{mealCount.dinner}</span>
                            <button
                              onClick={() => updateMealCount("dinner", "inc")}
                            >
                              +
                            </button>
                          </div>
                        </div>
                      )}

                      <hr />
                      <p>
                        <strong>Meal Total:</strong> ₹{mealTotal}
                      </p>

                      <div className="modal-actions">
                        <button onClick={() => setShowMealModal(false)}>
                          Cancel
                        </button>
                        <button onClick={() => setShowMealModal(false)}>
                          Apply for all Days
                        </button>
                      </div>
                    </div>
                  </div>
                )}

                <div className="room-meal-row">
                  <div className="room-input-wrapper">
                    <label className="room-label">Rooms</label>
                    <input
                      type="number"
                      min={1}
                      max={maxRooms}
                      value={roomsCount}
                      onChange={(e) => {
                        const value = Math.max(1, Number(e.target.value));
                        if (value > maxRooms) {
                          showToast(
                            `Only ${maxRooms} rooms available`,
                            "warning"
                          );
                          return;
                        }
                        setRoomsCount(value);
                      }}
                      className="room-input"
                    />
                  </div>

                  <button
                    onClick={() => setShowMealModal(true)}
                    className="add-meals-btn"
                  >
                    Add Meals 🍽️ (₹{mealTotal || 0})
                  </button>
                </div>

                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    label="Check-in Date"
                    value={checkIn ? dayjs(checkIn) : null}
                    minDate={dayjs()}
                    format="DD/MM/YYYY"
                    onChange={(value) => {
                      if (!value) return;
                      const checkInWithTime = applyStaticTime(
                        value,
                        hotelDetails?.check_in_time || "12:00"
                      );
                      setCheckIn(checkInWithTime);
                      setCheckOut(null);
                    }}
                    slotProps={{
                      textField: {
                        fullWidth: true,
                        required: true,
                        size: "small",
                      },
                    }}
                  />

                  <DatePicker
                    label="Check-out Date"
                    value={checkOut ? dayjs(checkOut) : null}
                    minDate={
                      checkIn ? dayjs(checkIn).add(1, "day") : dayjs()
                    }
                    format="DD/MM/YYYY"
                    disabled={!checkIn}
                    onChange={(value) => {
                      if (!value) return;
                      const checkOutWithTime = applyStaticTime(
                        value,
                        hotelDetails?.check_out_time || "10:00"
                      );
                      setCheckOut(checkOutWithTime);
                    }}
                    slotProps={{
                      textField: {
                        fullWidth: true,
                        required: true,
                        size: "small",
                      },
                    }}
                  />
                </LocalizationProvider>
              </div>

              <div className="hotelDetail-booking-actions">
                <button className="hotelDetail-bookBtn" onClick={BookNow}>
                  Book Now
                </button>
                <button
                  className="hotelDetail-bookBtn hotelDetail-bookBtn--green"
                  onClick={availability}
                >
                  Check availability
                </button>
              </div>
            </div>

            {/* Review Box */}
            <div className="hotelDetail-reviewBox animate-slideInUp">
              <div className="hotelDetail-reviewHeader">
                <span className="hotelDetail-reviewScore">
                  {totalRatings
                    ? (totalRatings / hotelreviews.length).toFixed(1)
                    : "0"}
                  ★
                </span>
                <span className="hotelDetail-reviewText">
                  {RatingsText(averageRating)}
                </span>
                <span className="hotelDetail-reviewCount">
                  ({hotelreviews.length} Reviews)
                </span>
              </div>

              <div className="hotelDetail-reviewLocation">
                <p className="hotelDetail-locationSub">
                  {hotelDetails?.land_mark}
                </p>
                <MapWrapper
                  mapHtml={hotelDetails?.map}
                  height="200px"
                  width="100%"
                />
              </div>

              <div className="hotelDetail-dealBox">
                <span className="hotelDetail-dealTitle">
                  Last Minute Deal
                </span>
                <p className="hotelDetail-dealText">
                  Congrats! You are getting a discount of ₹826 as a Last
                  Minute Deal offered by the property. Limited time offer
                  only!
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* ---------- MOBILE STICKY BAR ---------- */}
        <div className="hotelDetail-mobile-bookbar">
          <div className="hotelDetail-mobile-bookbar-price">
            <span>Total from</span>
            <strong>₹{roomTotalPrice}</strong>
            <small>
              {roomsCount} room{roomsCount > 1 ? "s" : ""} / day
            </small>
          </div>
          <button
            className="hotelDetail-mobile-bookbar-button"
            onClick={BookNow}
          >
            Book Now
          </button>
        </div>
      </div>

      {/* ================= REVIEWS ================= */}
      <div className="reviews_ratings">
        <div className="reviews_ratings-inner">
          <h4>Customer Reviews & Ratings</h4>
          <hr />

          <div className="review-card-uni">
            <div className="review-card-list">
              {hotelreviews.length === 0 ? (
                <h4>No Reviews Yet</h4>
              ) : (
                hotelreviews.map((review) => (
                  <div className="review-card-left-uni" key={review.id}>
                    <div className="review-card-header-uni">
                      <img
                        src={humanImg}
                        alt="User"
                        className="review-card-avatar-uni"
                      />
                      <div className="review-card-userinfo-uni">
                        <h3 className="review-card-name-uni">
                          {review?.user?.name}
                        </h3>
                        <div
                          className="review-card-stars-uni"
                          aria-label="rating"
                        >
                          {[...Array(review?.rating || 0)].map((_, i) => (
                            <svg
                              key={i}
                              viewBox="0 0 20 20"
                              className="star-uni"
                            >
                              <path d="M10 1.6l1.9 4 4.4.6-3.2 3 0.8 4.3L10 12.8 6.1 13.5l0.8-4.3L3.7 6.2l4.4-.6L10 1.6z" />
                            </svg>
                          ))}
                        </div>
                      </div>
                    </div>
                    <p className="review-card-text-uni">{review?.comment}</p>
                  </div>
                ))
              )}
            </div>

            <div className="review-card-breakdown-uni">
              <div className="review-card-summary-uni">
                <span className="review-card-summary-score">
                  {totalRatings
                    ? (totalRatings / hotelreviews.length).toFixed(1)
                    : "0"}
                  ★
                </span>
                <span className="review-card-summary-count">
                  {hotelreviews.length} Reviews
                </span>
                <span className="review-card-summary-count">
                  {totalRatings} Ratings
                </span>
              </div>

              <div className="review-card-bars-uni">
                {[5, 4, 3, 2, 1].map((r) => {
                  const pct =
                    hotelreviews.length > 0
                      ? (
                          (hotelreviews.filter((x) => x.rating === r).length /
                            hotelreviews.length) *
                          100
                        ).toFixed(1)
                      : 0;
                  return (
                    <div className="review-card-row-uni" key={r}>
                      <span className="review-card-label-uni">{r}★</span>
                      <div className="review-card-barwrap-uni">
                        <div
                          className="review-card-bar-uni"
                          style={{ width: `${pct}%` }}
                        />
                      </div>
                      <span className="review-card-percent-uni">{pct}%</span>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ================= RULES ================= */}
      <section className="hotel-rules-wrapper">
        <div className="hotel-rules-container">
          <h1 className="hotel-rules-title">
            🏨 Room Occupancy & Child Policy
          </h1>
          <p className="hotel-rules-subtitle">(Hotel Rules & Regulations)</p>

          <div className="rules-card fade-in">
            <h4>🛏️ रूम ऑक्यूपेंसी पॉलिसी</h4>
            <ul>
              <li>
                सभी कमरों में Base Occupancy 2 Adults रहेगी (Family Room को
                छोड़कर)।
              </li>
              <li>
                Extra Bed / Mattress केवल उपलब्ध स्थान के अनुसार और Chargeable
                रहेगा।
              </li>
              <li>
                Fire & Safety नियमों के अनुसार Maximum Occupancy से अधिक
                अनुमति नहीं होगी।
              </li>
            </ul>
          </div>

          <div className="rules-card slide-up">
            <h4>🏨 Room Category Wise Capacity</h4>
            <div className="capacity-grid">
              <div className="capacity-box">
                <h5>Standard / Deluxe / Super Deluxe / Executive</h5>
                <p>Base: 2 Adults</p>
                <p>Extra Bed: 1 Adult</p>
                <p>Extra Child: 1 (Without Bed)</p>
                <strong>Max: 3 Adults OR 2 Adults + 1 Child</strong>
              </div>
              <div className="capacity-box">
                <h5>Family Room</h5>
                <p>Base: 4 Adults</p>
                <p>Extra Bed: 1 Adult</p>
                <p>Extra Child: 1–2 Children</p>
                <strong>Max: 5 Adults OR 4 Adults + 1–2 Children</strong>
              </div>
              <div className="capacity-box">
                <h5>Suite Room</h5>
                <p>Base: 2 Adults</p>
                <p>Extra Bed: Up to 2 Adults</p>
                <p>Extra Child: Up to 2 Children</p>
                <strong>Max: 4 Adults + 2 Children</strong>
              </div>
            </div>
          </div>

          <div className="rules-card fade-in">
            <h4>👶 Child Policy</h4>
            <ul>
              <li>0–5 Years: Free (Without Bed)</li>
              <li>
                5–10 Years: Child charges applicable (Without Bed / Extra
                Mattress)
              </li>
              <li>
                Above 10 Years: Considered Adult (Extra Bed charges apply)
              </li>
            </ul>
          </div>

          <div className="rules-card slide-up">
            <h4>💰 Extra Bed Policy</h4>
            <ul>
              <li>Extra Bed / Mattress chargeable रहेगा।</li>
              <li>Room Size & Availability पर निर्भर करेगा।</li>
              <li>
                Standard category rooms में केवल 1 Extra Bed अनुमत है।
              </li>
            </ul>
          </div>

          <div className="rules-card warning">
            <h4>⚠️ Important Notes</h4>
            <ul>
              <li>Room sharing केवल Registered Guests के लिए अनुमत है।</li>
              <li>
                Overcrowding की स्थिति में होटल Extra Charges / Upgrade /
                Cancellation कर सकता है।
              </li>
              <li>Hotel Management का निर्णय अंतिम और मान्य होगा।</li>
            </ul>
          </div>
        </div>
      </section>
    </div>
  );
}

export default HotelDetails;